import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";
import Manavseva from "./Pages/Manavseva";
import Mochitimes from "./Pages/Mochitimes";
import Newsletter from "./Pages/Newsletter";
import Notifications from "./Pages/Notification";
import UserLog from "./Pages/Userlog";
import Logout from "./Pages/Logout";

function App() {
  const location = useLocation();

  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Error parsing user from localStorage:", error);
      localStorage.removeItem("user");
      return null;
    }
  });

  useEffect(() => {
    const handleStorageChange = () => {
      try {
        const storedUser = localStorage.getItem("user");
        setUser(storedUser ? JSON.parse(storedUser) : null);
      } catch (error) {
        console.error("Error syncing user from localStorage:", error);
        localStorage.removeItem("user");
        setUser(null);
      }
    };

    // Initial load
    handleStorageChange();

    // Listen for storage changes (e.g., from other tabs)
    window.addEventListener("storage", handleStorageChange);

    // Cleanup
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  // Handle logout
  const handleLogout = () => {
    console.log("Logging out...");
    localStorage.removeItem("user");
    setUser(null);
  };

  const hideDashboardOnRoutes = ["/login", "/logout"];
  const shouldShowDashboard =
    user && !hideDashboardOnRoutes.includes(location.pathname);

  // Log user state for debugging
  console.log("Current user state:", user);

  useEffect(() => {
    if (location.pathname === "/admin/login") {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [location.pathname]);

  return (
    <>
      {user ? <Dashboard /> : <Login />}
      <div className="App">
        <Routes>
          <Route
            path="/admin/login"
            element={
              !user ? (
                <Login setUser={setUser} />
              ) : (
                <Navigate to="/admin/manavseva" replace />
              )
            }
          />

          <Route
            path="/dashboard"
            element={user ? <Dashboard /> : <Navigate to="/admin/login" replace />}
          />

          <Route
            path="/manavseva"
            element={user ? <Manavseva /> : <Navigate to="/admin/login" replace />}
          />

          <Route
            path="/mochitimes"
            element={user ? <Mochitimes /> : <Navigate to="/admin/login" replace />}
          />

          <Route
            path="/newsletter"
            element={user ? <Newsletter /> : <Navigate to="/admin/login" replace />}
          />

          <Route
            path="/notifications"
            element={
              user ? <Notifications /> : <Navigate to="/admin/login" replace />
            }
          />

          <Route
            path="/userlog"
            element={user ? <UserLog /> : <Navigate to="/admin/login" replace />}
          />

          <Route
            path="/logout"
            element={
              user ? (
                <Logout handleLogout={handleLogout} />
              ) : (
                <Navigate to="/admin/login" replace />
              )
            }
          />

          <Route
            path="/"
            element={<Navigate to={user ? "/admin/manavseva" : "/admin/login"} replace />}
          />

          <Route
            path="*"
            element={<Navigate to={user ? "/admin/manavseva" : "/admin/login"} replace />}
          />
        </Routes>
      </div>
    </>
  );
}

export default App;
